import Cookies from "js-cookie";

export const SSO_CREDENTIALS_KEY = "ruijienetworks_sso_internal_certificate";
export const USER_CREDENTIALS_KEY = "ruijienetworks_user_credentials";
export const PARTNERS_TOKEN = "partners_token";
export const PARTNERS_TOKEN_COOKIE_CERT = "partners_token_cookie_cert";
export const PARTNERS_TOKEN_EXPIRED_TIME = "partners_token_expired_time";

export const removeAllCookie = () => {
  Cookies.remove(PARTNERS_TOKEN, { path: "/", domain: ".ruijie.com" });
  Cookies.remove(USER_CREDENTIALS_KEY, { path: "/", domain: ".ruijie.com" });
  Cookies.remove(SSO_CREDENTIALS_KEY, { path: "/", domain: ".ruijie.com" });
  Cookies.remove(PARTNERS_TOKEN_COOKIE_CERT, {
    path: "/",
    domain: ".ruijie.com",
  });
  Cookies.remove(PARTNERS_TOKEN_EXPIRED_TIME, {
    path: "/",
    domain: ".ruijie.com",
  });
};
